export const formatDate = (date) => {
  if (!date) return '';
    const dt = new Date(date);
    const month = getMonthName(dt.getMonth()); // + 1 because 0 indicates the first Month of the Year.
    const day = dt.getDate();
    const year = dt.getFullYear();
    const strDate = day > 9 ? day.toString() : `0${day}`;
    return `${strDate}-${month}-${year.toString().substr(-2)}`;
}


export const getMonthName = (month) => {
  switch(month)
  {
    case 0:
      return "Jan";
    case 1:
      return "Feb";
    case 2:
      return "Mar";
    case 3:
      return "Apr";
    case 4:
      return "May";
    case 5:
      return "Jun";
    case 6:
      return "Jul";
    case 7:
      return "Aug";
    case 8:
      return "Sep";
    case 9:
      return "Oct";
    case 10:
      return "Nov";
    case 11:
      return "Dec";
    default:
      return "Jan";
  }
}

function isValidCalendarDate(year, monthIndex, day) {
  const d = new Date(year, monthIndex, day);
  return (
    d.getFullYear() === year &&
    d.getMonth() === monthIndex &&
    d.getDate() === day
  );
}


export const formatIfsDocumentLastActionDisplay = (lastAction) => {
  if (!lastAction) return "-";

  const raw = String(lastAction);
  const m = raw.match(/^(\d{2})-(\d{2})-(\d{2})([\s\S]*)$/);
  if (m) {
    const mm = parseInt(m[1], 10);
    const dd = parseInt(m[2], 10);
    const yy = parseInt(m[3], 10);
    const year = yy < 100 ? 2000 + yy : yy;
    if (mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31 && isValidCalendarDate(year, mm - 1, dd)) {
      const prefix = `${dd}-${getMonthName(mm - 1)}-${String(yy).padStart(2, "0")}`;
      // Split camelCase only; do not insert before every capital (breaks "Checked-Out" → "Checked- Out").
      const rest = m[4]
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/\s+/g, " ");
      return (prefix + rest).trim();
    }
  }

  return raw
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim();
};